module.exports = __webpack_public_path__ + "img/Twitter.d8395ea8.svg";